import QuestionModel from "../QuestionModel";
import QuestionValue from "../QuestionValue";
import QuestionValueSum from "../QuestionValueSum";
import QuestionModule from "./QuestionModule";

export default class QuestionModuleSum extends QuestionModule {
    constructor() {
        super();
    }

    create(data) {
        const question = super.create(data);
        question.selectMultiNum = data.select_multi_num ? data.select_multi_num : 1;

        switch (data.type) {
            case QuestionModel.TYPE_ADDITION: {
                this.generateOptionsAddition(question, data);
                break;
            }
            case QuestionModel.TYPE_SUBTRACTION: {
                this.generateOptionsSubtraction(question, data);
                break;
            }
            case QuestionModel.TYPE_MULTIPLICATION: {
                this.generateOptionsMultiplication(question, data);
                break;
            }
            case QuestionModel.TYPE_DIVISION: {
                this.generateOptionsDivision(question, data);
                break;
            }
        }

        this.generateOptions(question, data);
        return question;
    }

    generateOptionsAddition(question, data) {
        //find two sums with the same answer : [2113 + 133] [3214 + 134] etc

        //so first lets just find any old number as our number that is the same
        const result = P3.math.randomInt(data.range.min, data.range.max);

        //then negate some random numbers to produce our two option correct option statements
        const optionDifference1 = P3.math.randomInt(data.range.min * 0.5, result * 0.5);
        const optionValue1 = new QuestionValueSum(result - optionDifference1, "+", optionDifference1);
        question.options.push(optionValue1);

        //make sure difference two is unique
        let n = 100;
        let optionDifference2 = optionDifference1;
        while (n-- > 0 && optionDifference1 === optionDifference2) {
            optionDifference2 = P3.math.randomInt(data.range.min * 0.5, result * 0.5);
        }

        const optionValue2 = new QuestionValueSum(result - optionDifference2, "+", optionDifference2);
        question.options.push(optionValue2);

        //we have our two correct options, lets make some dummies
        const arr = [result];
        n = 100;
        while (n-- > 0 && question.options.length < 5) {
            const dummyResult = P3.math.randomInt(data.range.min, data.range.max);
            if (arr.indexOf(dummyResult) === -1) {
                arr.push(dummyResult);

                const difference = P3.math.randomInt(data.range.min * 0.5, dummyResult * 0.5);
                question.options.push(new QuestionValueSum(dummyResult - difference, "+", difference));
            }
        }

        P3.utils.shuffleArray(question.options);

        //only need to add our correct result to values so we can check user is correct
        question.values.push(new QuestionValue(result));
        question.part = 0;
    }

    generateOptionsSubtraction(question, data) {
        //find two sums with the same answer : [2113 + 133] [3214 + 134] etc

        //so first lets just find any old number as our number that is the same
        const result = P3.math.randomInt(data.range.min, data.range.max);

        //then negate some random numbers to produce our two option correct option statements
        const optionDifference1 = P3.math.randomInt(data.range.min * 0.5, result * 0.5);
        const optionValue1 = new QuestionValueSum(result + optionDifference1, "-", optionDifference1);
        question.options.push(optionValue1);

        //make sure difference two is unique
        let n = 100;
        let optionDifference2 = optionDifference1;
        while (n-- > 0 && optionDifference1 === optionDifference2) {
            optionDifference2 = P3.math.randomInt(data.range.min * 0.5, result * 0.5);
        }

        const optionValue2 = new QuestionValueSum(result + optionDifference2, "-", optionDifference2);
        question.options.push(optionValue2);

        //we have our two correct options, lets make some dummies
        const arr = [result];
        n = 100;
        while (n-- > 0 && question.options.length < 5) {
            const dummyResult = P3.math.randomInt(data.range.min, data.range.max);
            if (arr.indexOf(dummyResult) === -1) {
                arr.push(dummyResult);

                const difference = P3.math.randomInt(data.range.min * 0.5, dummyResult * 0.5);
                question.options.push(new QuestionValueSum(dummyResult + difference, "-", difference));
            }
        }

        P3.utils.shuffleArray(question.options);

        //only need to add our correct result to values so we can check user is correct
        question.values.push(new QuestionValue(result));
        question.part = 0;
    }

    generateOptionsMultiplication(question, data) {
        //find two sums with the same answer : [2113 + 133] [3214 + 134] etc

        if (data.sum_type === "equal_to") {
            //this one requires slightly different treatment. instead we will calculate the result
            let leftA, rightA, coefficient;

            let n = 100;
            while (n-- > 0) {
                leftA = P3.math.randomInt(data.range.min, data.range.max);
                rightA = P3.math.randomInt(data.range.min, data.range.max);

                coefficient = P3.math.randomInt(data.range.min, data.range.max * 0.5);

                //are both left and right factors of coefficient?
                if (leftA % coefficient === 0 && rightA % coefficient === 0) {
                    break;
                }
            }

            const result = leftA * rightA;

            let leftB, rightB;

            if (Math.random() < 0.5) {
                leftB = leftA / coefficient;
                rightB = rightA * coefficient;
            } else {
                leftB = leftA * coefficient;
                rightB = rightA / coefficient;
            }

            // const a = new QuestionValueSum(leftA, "*", rightA);
            //a.operand = "×";

            const b = new QuestionValueSum(leftB, "*", rightB);
            b.operand = "×";

            question.options.push(b);

            n = 100;
            const arr = [result];
            while (n-- > 0 && question.options.length < 5) {
                const left = P3.math.randomInt(data.range.min, data.range.max);
                const right = P3.math.randomInt(data.range.min, data.range.max);

                if (arr.indexOf(left * right) === -1) {
                    arr.push(left * right);

                    const option = new QuestionValueSum(left, "*", right);
                    option.operand = "×";
                    question.options.push(option);
                }
            }

            question.values.push(new QuestionValue(leftA));
            question.values.push(new QuestionValue(rightA));
            question.values.push(new QuestionValue(result));
            question.part = 2;

            P3.utils.shuffleArray(question.options);

        } else {

            let leftA, rightA, coefficient;

            let n = 100;
            while (n-- > 0) {
                leftA = P3.math.randomInt(data.range.min, data.range.max);
                rightA = P3.math.randomInt(data.range.min, data.range.max);

                coefficient = P3.math.randomInt(4, 12);

                //are both left and right factors of coefficient?
                if (leftA % coefficient === 0 && rightA % coefficient === 0) {
                    break;
                }
            }

            const result = leftA * rightA;
            question.values.push(new QuestionValue(result));

            //lets work out options that give same result
            n = 100;
            const arr = [];
            while (n-- > 0 && question.options.length < 4) {

                const coefficient2 = P3.math.randomInt(2, 40);

                if (leftA % coefficient2 === 0) {
                    let left, right;


                    left = leftA / coefficient2;
                    right = rightA * coefficient2;

                    const stringed = "" + left + "*" + right;

                    if (arr.indexOf(stringed) === -1) {
                        arr.push(stringed);
                        const option = new QuestionValueSum(left, "*", right);
                        option.operand = "×";
                        question.options.push(option);
                    }
                } else if (rightA % coefficient2 === 0) {
                    let left, right;

                    left = leftA * coefficient2;
                    right = rightA / coefficient2;

                    const stringed = "" + left + "*" + right;

                    if (arr.indexOf(stringed) === -1) {
                        arr.push(stringed);
                        const option = new QuestionValueSum(left, "*", right);
                        option.operand = "×";
                        question.options.push(option);
                    }
                }
            }

            /*
            //ugly code but pushed for time, if we didnt fill just go ahead and try again but allow duplicates
            if (question.options.length < 4) {
                n = 100;
                while (n-- > 0 && question.options.length < 4) {

                    const coefficient2 = P3.math.randomInt(2, 40);

                    if (leftA % coefficient2 === 0 && rightA % coefficient2 === 0) {
                        let left, right;

                        if (Math.random() < 0.5) {
                            left = leftA / coefficient2;
                            right = rightA * coefficient2;
                        } else {
                            left = leftA * coefficient2;
                            right = rightA / coefficient2;
                        }

                        const option = new QuestionValueSum(left, "*", right);
                        option.operand = "×";
                        question.options.push(option);

                    }
                }
            }

            //okay this is horrible now but if we still didn't manage to do it after all this time, just fill with 1 x result
            if (question.options.length < 4) {
                while (question.options.length < 4) {
                    if (Math.random() < 0.5) {
                        const option = new QuestionValueSum(result, "*", 1);
                        option.operand = "×";
                        question.options.push(option);
                    } else {
                        const option = new QuestionValueSum(1, "*", result);
                        option.operand = "×";
                        question.options.push(option);
                    }
                }
            }
            */

            //now lets find a statement that gives a different result
            n = 100;
            let a, b;
            let correctResult = result;
            while (n-- > 0 && correctResult === result) {
                a = P3.math.randomInt(data.range.min, data.range.max);
                b = P3.math.randomInt(data.range.min, data.range.max);
                correctResult = a * b;
            }

            const correctOption = new QuestionValueSum(a, "*", b);
            correctOption.operand = "×";

            question.options.push(correctOption);

            question.values.push(new QuestionValue(correctOption.value));
            question.part = question.values.length - 1;

            P3.utils.shuffleArray(question.options);
        }
    }

    generateOptionsDivision(question, data) {
        //find two sums with the same answer : [2113 + 133] [3214 + 134] etc

        if (data.sum_type === "equal_to") {
            //so first lets just find any old number as our number that is the same
            const result = P3.math.randomInt(data.range.min, data.range.max);

            //then negate some random numbers to produce our two option correct option statements
            const optionDifference1 = P3.math.randomInt(data.range.min * 0.5, result * 0.5);
            const optionValue1 = new QuestionValueSum(result * optionDifference1, "/", optionDifference1);
            question.options.push(optionValue1);

            //make sure difference two is unique
            let n = 100;
            let optionDifference2 = optionDifference1;
            while (n-- > 0 && optionDifference1 === optionDifference2) {
                optionDifference2 = P3.math.randomInt(data.range.min * 0.5, result * 0.5);
            }

            const optionValue2 = new QuestionValueSum(result * optionDifference2, "/", optionDifference2);
            question.options.push(optionValue2);

            //we have our two correct options, lets make some dummies
            const arr = [result];
            n = 100;
            while (n-- > 0 && question.options.length < 5) {
                const dummyResult = P3.math.randomInt(data.range.min, data.range.max);
                if (arr.indexOf(dummyResult) === -1) {
                    arr.push(dummyResult);

                    const difference = P3.math.randomInt(data.range.min * 0.5, dummyResult * 0.5);
                    question.options.push(new QuestionValueSum(dummyResult * difference, "/", difference));
                }
            }

            P3.utils.shuffleArray(question.options);

            //only need to add our correct result to values so we can check user is correct
            question.values.push(new QuestionValue(result));
            question.part = 0;
        } else {
            //find the odd one out of these sums : [2113 + 133] [3214 + 134] etc

            //so first lets just find any old number as our number that is the same
            const result = P3.math.randomInt(data.range.min, data.range.max);

            //fill options with statements that give same result, leaving room for our correct answer
            const arr = [];
            let n = 100;
            while (n-- > 0 && question.options.length < 4) {
                const optionDifference = P3.math.randomInt(Math.round(data.range.min * 0.5), Math.round(result * 0.5));
                if (arr.indexOf(optionDifference) === -1) {
                    const optionValue = new QuestionValueSum(result * optionDifference, "/", optionDifference);
                    optionValue.operand = "÷"; //quick dirty, need to change its symbol
                    question.options.push(optionValue);
                    arr.push(optionDifference);
                }
            }

            //if options is length 1, try again, but allow duplicates
            n = 100;
            while (n-- > 0 && question.options.length < 4) {
                const optionDifference = P3.math.randomInt(Math.round(data.range.min * 0.5), Math.round(result * 0.5));
                const optionValue = new QuestionValueSum(result * optionDifference, "/", optionDifference);
                optionValue.operand = "÷";
                question.options.push(optionValue);
            }

            //now we just need to find a number that is not the same as the result, and do the same again
            let correctResult = result;
            n = 100;
            while (n-- > 0 && correctResult === result) {
                correctResult = P3.math.randomInt(data.range.min, data.range.max);
            }

            const optionDifference = P3.math.randomInt(Math.round(data.range.min * 0.5), Math.round(correctResult * 0.5));

            const correctOption = new QuestionValueSum(correctResult * optionDifference, "/", optionDifference);
            correctOption.operand = "÷";
            question.options.push(correctOption);

            P3.utils.shuffleArray(question.options);

            question.values.push(new QuestionValue(correctOption.value));
            question.part = 0;
        }
    }

    /*
    create(data) {
        const question = super.create(data);

        question.options = this.generateOptions(question, data.values, data.operands, data.sum_type, data.options_range, data.select_multi_num);
        return question;
    }

    generateOptions(question, count, operands, sum_type, options_range, select_multi_num) {

        question.sum_type = sum_type;
        question.select_multi_num = select_multi_num;

        const possibleValues = [];
        for (let i = question.range.min; i <= question.range.max; i++) {
            if (count > 1 || !this.isPrime(i)) possibleValues.push(i);
        }
        //Generate the target value and operands that create it.
        let target;
        for (let i = 0; i < count; i++) {
            let val = possibleValues.splice(this.rand(0, possibleValues.length - 1), 1)[0];
            if (i === 0)
                target = val;
            else {
                if (question.type === 'addition') {
                    target = target + val;
                }
                else if (question.type === 'subtraction') {
                    target = target - val;
                }
                else if (question.type === 'multiplication') {
                    target = target * val;
                }
                else if (question.type === 'division') {
                    while (target % val !== 0) {
                        val = this.rand(question.range.min, question.range.max);
                    }
                    target = target / val;
                }
            }
            question.values.push(new QuestionValue(val));
        }
        if (count > 1) {
            question.values.push(new QuestionValue(target));
        }

        //Generate correct and incorrect sums as options to equal the target
        const value = Number(question.values[question.values.length - 1]);
        const options = [];
        const totalSums = this.rand(options_range.min, options_range.max);
        const correctSums = question.sum_type === 'equal_to' ? (select_multi_num || 1) : totalSums - 1;
        const correctAddSubComponents = [];
        const divisors = this.getDivisors(value);
        const multipliers = this.getMultipliers(value);

        const optionTotals = [];

        for (let i = 0; i < totalSums; i++) {
            let t = value;
            if (i >= correctSums) {
                //choose a random amount for an incorrect sum to equal
                let loops = 0;
                while (t === value || this.isPrime(t) || optionTotals.indexOf(t) > -1) {
                    t = t + Math.round(t * this.randDec(-0.3, 0.3 + (0.1 * Math.floor(loops / 10))));
                    loops++;
                }
                optionTotals.push(t);
            }
            let string = '';
            let ops = Math.min(3, Math.max(2, this.rand(operands.min, operands.max)));
            let num = null;

            //Get a random amount to add to or remove from the value to create a sum with three operands, e.g 2x3+6
            if (ops === 3) {
                let sign;
                let v = t;
                while (v === t || this.isPrime(v)) {
                    let r = this.randDec(0.1, 0.5);
                    num = Math.round(t * r);
                    sign = Math.random() > 0.5 ? '+' : '-';
                    v = sign === '+' ? Number(t - num) : Number(t + num);
                    //console.log(r, num, v);
                }
                t = v;
                string = sign + String(num);
            }
            if (question.type === 'addition' || question.type === 'subtraction') {

                num = Math.round(t * this.randDec(0.1, 0.5));
                if (i < correctSums) {
                    while (correctAddSubComponents.indexOf(num) > -1) {
                        num = Math.round(t * this.randDec(0.1, 0.5));
                    }
                }
                if (question.type === 'addition') {
                    string = String(num) + ' + ' + String(t - num) + string;
                    if (i < correctSums) {
                        correctAddSubComponents.push(num, t - num)
                    }
                }
                else if (question.type === 'subtraction') {
                    string = String(t + num) + ' - ' + String(num) + string;
                    if (i < correctSums) {
                        correctAddSubComponents.push(num, t + num)
                    }
                }
                //console.log(correctAddSubComponents);
            }
            else if (question.type === 'multiplication') {
                if (i < correctSums && ops === 2) {
                    if (divisors.length === 0) num = 1;
                    else {
                        num = divisors.splice(this.rand(0, divisors.length - 1), 1)[0];
                    }
                }
                else {
                    num = P3.utils.shuffleArray(this.getDivisors(t))[0];
                }
                string = String(num) + ' x ' + String(t / num) + string;
                //console.log(num + '*(' + t + '/' + num + ') = ' + t );
                //console.log(string + ' = ' + t);
            }
            else if (question.type === 'division') {
                if (i < correctSums) {
                    num = multipliers.splice(this.rand(0, multipliers.length - 1), 1)[0];
                }
                else {
                    num = P3.utils.shuffleArray(this.getMultipliers())[0];
                }
                string = String(t * num) + ' ÷ ' + String(num) + string;
            }

            options.push(new QuestionValue(string));
        }

        P3.utils.shuffleArray(options);

        return options;
    }

    rand(min, max) {
        return P3.math.randomInt(min, max);
    }

    randDec(min, max) {
        return min + (Math.random() * (max - min));
    }

    getDivisors(num) {
        const arr = [];
        for (let i = 2; i < num; i++) {
            if (num % i === 0) arr.push(i);
        }
        return arr;
    }

    getMultipliers() {
        const arr = [];
        for (let i = 2; i <= 12; i++) {
            arr.push(i);
        }
        return arr;
    }

    isPrime(num) {
        for (let i = 2; i < num; i++)
            if (num % i === 0) return false;
        return num > 1;
    }

    isMultipleOf(a, b) {
        if (b % a === 0) return true;
        return false;
    }
    */
}